import { defineMessages } from 'react-intl';

const messages = defineMessages({
  name: {
    id: 'role.name',
    defaultMessage: 'Name',
    description: 'Label for name in role',
  },
});

export default messages;
